import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Alert, Box, CircularProgress, Tab, Typography } from '@mui/material';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useRootReadQuery } from '../api/root.js';
import { AnalysisList } from './AnalysisList.js';
import { SnapshotList } from './SnapshotList.js';

type RootViewParams = {
  projectId: string;
  rootId: string;
};

export function RootView() {
  const { projectId, rootId } = useParams<RootViewParams>();
  if (!projectId || !rootId) throw new Error('Missing parameter');

  const [value, setValue] = useState(0);
  const handleChange = (event: any, newValue: number) => {
    setValue(newValue);
  };

  const root = useRootReadQuery(projectId, rootId);
  if (root.isLoading) return <CircularProgress />;
  if (root.isError) return <Alert severity="error">{`Error: ${root.error.message}`}</Alert>;

  return (
    <Box>
      <Box>
        <Typography variant="h5">Root {root.data.hostname}</Typography>
      </Box>
      <TabContext value={value.toString()}>
        <TabList value={value} onChange={handleChange}>
          <Tab label="Snapshots" value="0" />
          <Tab label="Analyses" value="1" />
          <Tab label="Details" value="2" />
        </TabList>

        <TabPanel value="0">
          <SnapshotList type="transparency" projectId={projectId} resourceId={rootId} />
        </TabPanel>

        <TabPanel value="1">
          <AnalysisList type="transparency" projectId={projectId} resourceId={rootId} />
        </TabPanel>
        <TabPanel value="2">
          <Typography variant="h5">Test Details</Typography>
          <pre>{JSON.stringify(root.data, null, 2)}</pre>
        </TabPanel>
      </TabContext>
    </Box>
  );
}
